import * as React from 'react';

const useLocalStorage = <S>(key: string): [S | null, (value: S) => void] => {
  const [data, setStateData] = React.useState<S | null>(() => {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  });

  const setData = (value: S): void => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      // See https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem#exceptions
      // pass
    }

    setStateData(value);
  };

  return [data, setData];
};

export default useLocalStorage;
